import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ecouterLiens } from '../../native/liens';
import { ecouterOuvertures } from '../../native/notifications';
import { useSession } from '../../store/SessionContext';

/**
 * Le routeur, branche sur ce qui vient de l'exterieur.
 *
 * Deux sources, une seule regle d'atterrissage : une notification
 * touchee, et une adresse `sirocco://` — celle qu'ouvre la page d'accueil
 * d'un post partage hors de l'application.
 *
 * Rien a l'ecran : ce composant n'existe que pour tenir un `useNavigate`
 * a l'interieur du routeur et le passer a la couche native, qui ecoute
 * depuis le lancement — bien avant que React soit la.
 *
 * **Il attend que l'application ait fini d'atterrir.** Mesure faite sur
 * l'appareil : touchee application fermee, la notification arrive huit
 * millisecondes apres le lancement — le routeur n'existe pas encore, la
 * destination est mise de cote, et l'application poursuit son propre
 * atterrissage. Sa redirection d'accueil (`landingFor`) partait alors
 * *apres* la notre et l'effacait : on se retrouvait sur le fil, ce qui
 * ressemblait a s'y meprendre a « ca ouvre juste l'appli ».
 *
 * Le signal qu'on est arrive, c'est une adresse en `/app/`. Tant qu'on
 * n'y est pas, la destination patiente ; des qu'on y est, elle part et
 * plus rien ne la couvre.
 */
export function OuvertureNotif() {
  const navigate = useNavigate();
  const { user, server, loading } = useSession();

  const { pathname } = useLocation();
  const atterri = pathname.startsWith('/app/');

  useEffect(() => {
    if (loading || !user || !server || !atterri) return;
    const arrets = [
      ecouterOuvertures((route) => navigate(route)),
      ecouterLiens((route) => navigate(route)),
    ];
    return () => arrets.forEach((arret) => arret());
  }, [loading, user, server, atterri, navigate]);

  return null;
}
